import { ForwardedRef, forwardRef } from 'react'

import classNames from 'classnames'

import Clickable from '@web/components/Clickable'
import { Nullish } from '@web/types'

import ProgressCircle from './ProgressCircle'
import styles from './ProgressStamp.module.scss'
import CircleAnimationStamp from '../../../MissionStamp/CircleAnimationStamp'
import CircleOverAnimation from '../../../MissionStamp/CircleOverAnimation'

export interface ProgressStampItemProps {
  total: number
  title: string
  description: string
  count: number
  image?: Nullish<string>
  number?: number
  classname?: string
  onClick?: () => void
  withAnimation?: boolean
  animationOrder?: number
  allowOver: boolean
}
const ProgressStampItem = (
  {
    total,
    count,
    title,
    description,
    image,
    number = 1,
    withAnimation = false,
    classname,
    onClick,
    animationOrder = 1,
    allowOver,
  }: ProgressStampItemProps,
  ref: ForwardedRef<HTMLLIElement>,
) => {
  const isOver = count > total

  return (
    <li ref={ref} className={classNames(styles.list_item, classname)}>
      <div className={styles.list_item_inner}>
        {withAnimation ? (
          isOver ? (
            <CircleOverAnimation total={total} count={count} number={number} image={image} order={animationOrder} />
          ) : (
            <CircleAnimationStamp total={total} count={count} number={number} image={image} order={animationOrder} />
          )
        ) : (
          <ProgressCircle total={total} count={count} number={number} image={image} allowOver={allowOver} />
        )}
        <div className={styles.info_area}>
          <div className={styles.tit_area}>{title}</div>
          <div className={styles.count_area}>{description}</div>
        </div>

        {onClick && (
          <Clickable className={styles.link} onClick={onClick}>
            리뷰 보기
          </Clickable>
        )}
      </div>
    </li>
  )
}

export default forwardRef(ProgressStampItem)
